require('./badgeController.js')
require('./badgesController.js')
require('./deletePrivateAccountController.js')
require('./privateUserController.js')
require('./userController.js')